module.exports = __webpack_public_path__ + "static/media/logoCastellonPlaza.b5865c7e.png";